import {Queue} from "../utils/SetUtils";
import {createSSE, doLoginAsVisitor, reloginInBg} from "../api/home-api";
import {isnull, localClear, localGet, localSave} from "../utils/tools";
import IMManager from "../im/IMManager";
import global from "../config/global";

export default class NetHelper {
  static inReLogin = false
  static sucPending4ReLogin = new Queue()
  static failPending4ReLogin = new Queue()

  static async relogin(vuePage, successCallback = null, failCallback = null) {
    if (!isnull(successCallback))
      NetHelper.sucPending4ReLogin.push(successCallback)
    if (!isnull(failCallback))
      NetHelper.failPending4ReLogin.push(failCallback)
    if (NetHelper.inReLogin) {
      return
    }
    NetHelper.inReLogin = true
    if (global.isNormal()) {
      reloginInBg((data, page) => {
        NetHelper.dealData(data, page)
      }, (code, msg, page) => {
        if (code == -10) {
          this.visitor(vuePage)
        } else
          NetHelper.dealFail(code, msg, page)
      }, vuePage, false, false).catch(e => {
        console.log(e)
        NetHelper.dealFail(-1, '', vuePage)
      })
    } else {
      this.visitor(vuePage)
    }
  }

  static visitor(vuePage) {
    doLoginAsVisitor((data, page) => {
      NetHelper.dealData(data, page)
    }, (code, msg, page) => {
      NetHelper.dealFail(code, msg, page)
    }, vuePage, false, false).catch(e => {
      console.log(e)
      NetHelper.dealFail(-1, '', vuePage)
    })
  }

  static dealData(res, page) {
    NetHelper.inReLogin = false

    if (page.$root.$sseClient) {
      page.$root.$sseClient.disconnect()
      page.$root.$sseClient = null
    }
    page.$globalAppCfg.sseSource = null
    page.$globalAppCfg.setUser({})
    page.$globalAppCfg.setSession('')
    page.$globalAppCfg.setGlobalParams({})
    if (page.$root.rtm && page.$root.rtm._logined) {
      page.$root.rtm.logout().then(() => {
        console.log('logout')
        page.$root.rtm._logined = false
        page.$root.$globalAppCfg.agoChatClient = null
      }).catch((err) => {
        console.log('Logout failed, please open console see more details')
        console.log(err)
      })
    }
    IMManager.exit(page)
    localClear()
    global.setUser(res.user)
    global.setGlobalParams(res.globalParam)
    global.setVideoChatRoomConfig(res.globalParam.videoChatRoomConfig)
    global.setSession(res.session)
    if (localGet(global.key.session) != res.session) {
      page.$root.$sseClient = null
    }
    localSave(global.key.session, res.session)
    global.saveUser(res.user)
    if (!isnull(res.globalParam)) {
      global.saveServerCFG(res.globalParam)
      localSave(global.key.video_chat_config, JSON.stringify(res.globalParam.videoChatRoomConfig))
    }
    global.setPList(res.globalParam.payConfigs)
    localSave(global.LOGIN_STATUS, true)
    createSSE(res.session, page)
    page.$root.rtmManager.login()


    let next = NetHelper.sucPending4ReLogin.pop()
    while (!isnull(next)) {
      next(res, page)
      next = NetHelper.sucPending4ReLogin.pop()
    }
  }

  static dealFail(code, msg, page) {
    NetHelper.inReLogin = false
    localSave(global.key.RENEW, true)
    let next = NetHelper.failPending4ReLogin.pop()
    while (!isnull(next)) {
      next(code, msg, page)
      next = NetHelper.failPending4ReLogin.pop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/apiconfig/nethelper.js